import React from "react";

import { AlternativeLabel } from "../../styles";
import FacebookAuthButton from "../../FacebookAuthButton";
import GoogleLoginButton from "../../GoogleLoginButton";

import { CtaButton, FormInputStyled } from "../styles";

import { useLoginFlow } from "../Context";

import { validNameOrEmail } from "../../helpers";

const DefaultView = () => {
    const { emailAddress, setEmailAddress, goToPasswordLoginView, hasSocial } =
        useLoginFlow();

    return (
        <>
            <FormInputStyled
                name="username"
                labelText="Email Address"
                autocomplete="username"
                placeholderText="yourname@domain.com"
                value={emailAddress}
                onChange={setEmailAddress}
                validation={[
                    {
                        errorMsg: "Please enter a valid email.",
                        isValid: validNameOrEmail,
                    },
                ]}
                type="text"
                data-testid="email-address-input"
            />
            <CtaButton
                onClick={e => {
                    e.preventDefault();
                    goToPasswordLoginView();
                }}
                isDisabled={!validNameOrEmail(emailAddress)}
            >
                Next
            </CtaButton>
            {hasSocial && (
                <>
                    <AlternativeLabel>or</AlternativeLabel>
                    <GoogleLoginButton />
                    <FacebookAuthButton>
                        Sign in with Facebook
                    </FacebookAuthButton>
                </>
            )}
        </>
    );
};

export default DefaultView;
